import { useContext, useState } from "react";
import { NavLink, useLocation, useSearchParams } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import CollapsibleSidebar from "./CollapsibleSidebar";

const SidebarComponent = ({ open, setOpen }) => {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const patientId = searchParams.get("patientId") ?? "";
  const patientName = searchParams.get("patientName") ?? "";
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Add this
  const Menus = [
    {
      title: "Blood Report",
      href: "/blood-report",
      icon: "fas fa-tint",
      color: "text-red-400",
    },
    {
      title: "Intelli Lab",
      href: "/",
      icon: "fas fa-magic",
      color: "text-blue-300",
    },
    {
      title: "Lab-Compliance",
      href: "/lab-compilance",
      icon: "fas fa-file-medical-alt",
      color: "text-green-300",
    },
    {
      title: "Lab-Reconciliation",
      href: "/lab-center",
      icon: "fas fa-exchange-alt",
      color: "text-yellow-300",
    },
    {
      title: "Patient List",
      href: "/patient-list",
      icon: "fas fa-users",
      color: "text-cyan-300",
    },
    {
      title: "STI Report",
      href: "/sti-report",
      icon: "fas fa-virus",
      color: "text-pink-400",
    },
    {
      title: "Tox Report",
      href: "/tox-report",
      icon: "fas fa-biohazard",
      color: "text-purple-400",
    },
  ];

  const filteredMenus =
    location.pathname === "/patient-dashboard" || patientId !== ""
      ? Menus.filter((menu) =>
        ["Blood Report", "Tox Report", "STI Report"].includes(menu.title),
      )
      : Menus;

  return (
    <div
      className={`w-full ${patientId ? "bg-emerald-500" : "bg-yellow-50"} p-2 flex items-center`}
    >
      <CollapsibleSidebar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
      />
      <ul className="flex gap-4 w-full justify-start items-center">
        <button onClick={() => setIsSidebarOpen(true)} className="text-white">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6 text-gray-700"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        {filteredMenus.map((link, index) => (
          <li key={index}>
            {link.external ? (
              <a
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-x-1 text-white hover:text-orange-300"
              >
                <i className={`${link.icon} ${link.color} text-base`}></i>
                <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 whitespace-nowrap bg-black text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition-all duration-200 z-20">
                  {link.title}
                </span>
                {/* <span className="hidden sm:inline">{link.title}</span> */}
              </a>
            ) : (
              <NavLink
                to={
                  patientId
                    ? `${link.href}?patientId=${patientId}&patientName=${patientName}`
                    : link.href
                }
                className={({ isActive }) =>
                  `relative group flex items-center gap-x-1 px-3 py-1 rounded-md text-white hover:bg-white hover:text-black ${isActive ? "bg-orange text-white font-bold" : ""
                  }`
                }
              >
                <i className={`${link.icon} ${link.color} text-base`}></i>

                {/* Tooltip */}
                <div className="absolute top-1.5 left-1/2 transform -translate-x-1/2 mt-1 px-2 py-1 text-xs whitespace-nowrap bg-black text-white rounded opacity-0 group-hover:opacity-100 transition duration-300 z-50">
                  {link.title}
                </div>
              </NavLink>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SidebarComponent;
